import moment from 'moment';
import 'moment-timezone';
import Storage from './Storage';
import { StorageKey } from 'src/latest/src/constants/StorageKey';
import { getAccessToken, saveCredential } from 'src/latest/src/auth/authStore';

/**
 * Whether there is a usable session right now. Reads the accessor rather than
 * storage: with a memory-only token the key this used to read is never written
 * and is purged at startup, so it would answer `false` forever — and the only
 * caller is the idle timer's enable condition (AppContainer.js:407), which
 * would then stop arming with no visible symptom at all.
 * @returns {Boolean} true when a token is held
 */
export const checkAuthorization = () => Boolean(getAccessToken());

export const getAuthToken = () => {
  const accessToken = Storage.getItem(StorageKey.accessToken);

  if (accessToken == null) {
    return null;
  }

  return JSON.parse(accessToken);
};

/**
 * Persist a new session's credential. Only the credential (and `id`, see
 * authStore) is kept; role, name and avatar go through authUser() /
 * updateLoggedInUser() into the redux authentication slice.
 * @param {Object} sessionDetails a /token (or equivalent) response
 * @returns {void}
 */
export const saveAuthorizationToken = (sessionDetails: any) =>
  saveCredential(sessionDetails);

export function isTokenValid(date: string) {
  const dateObj = new Date(date);
  const timeZone = moment.tz.guess();
  const momentObj = moment(dateObj).tz(timeZone).format();

  return moment().isBefore(momentObj);
}
